/* eslint-disable import/prefer-default-export, eqeqeq */
export const dayChangeRate = (prev, now) => {
  if (Number.isNaN(prev) || Number.isNaN(now)) return undefined;
  if (prev == 0) return (((now - prev) * 100) / 1).toFixed(2);
  return (((now - prev) * 100) / prev).toFixed(2);
};
